/**
 * Shared helpers for login OTP challenge detection and UI prop mapping.
 * Used by email and phone login flows.
 */

export const hasLoginOtpChallenge = (login) =>
  login?.loginOtpRequired === true && login?.loginOtpChallenge != null;

/**
 * @param {Object} login - login response payload
 * @param {Object} [options]
 * @param {boolean} [options.requireOtpAuthenticationEnabledWebsite=false]
 * @param {boolean} [options.otpAuthenticationEnabledWebsite=false]
 */
export const shouldUseLoginOtpChallenge = (
  login,
  {
    requireOtpAuthenticationEnabledWebsite = false,
    otpAuthenticationEnabledWebsite = false,
  } = {}
) => {
  if (!hasLoginOtpChallenge(login)) {
    return false;
  }

  if (requireOtpAuthenticationEnabledWebsite) {
    return otpAuthenticationEnabledWebsite === true;
  }

  return true;
};

/**
 * Maps API challenge + customer data to LoginOtpChallenge component props.
 * @param {Object} challenge - loginOtpChallenge from login response
 * @param {Object} [customer]
 * @param {Object} [options]
 * @param {Object} [options.phoneNumber] - fallback phone from login form
 * @param {boolean} [options.defaultMustSelectChannel=true]
 * @param {boolean} [options.hideTrustDeviceOption=false]
 */
export const mapLoginOtpChallengeProps = (
  challenge,
  customer = {},
  {
    phoneNumber = {},
    defaultMustSelectChannel = true,
    hideTrustDeviceOption = false,
  } = {}
) => ({
  challengeId: challenge.id,
  availableChannels: Array.isArray(challenge.availableChannels)
    ? challenge.availableChannels.filter(Boolean)
    : [],
  mustSelectChannel: challenge.mustSelectChannel ?? defaultMustSelectChannel,
  expiresAt: challenge.expiresAt,
  attemptsRemaining: challenge.attemptsRemaining || 5,
  maxAttempts: challenge.maxAttempts || 5,
  resendAvailableInSeconds: challenge.resendAvailableInSeconds || 0,
  customerEmail: customer?.email || '',
  customerPhone: customer?.phoneTelephone || customer?.telephone || phoneNumber?.phone || '',
  customerPhoneCode: customer?.prefixTelephone || phoneNumber?.code || '+1',
  hideTrustDeviceOption,
});
